import { render, staticRenderFns } from "./GSTR.vue?vue&type=template&id=7057fa3f"
import script from "./GSTR.vue?vue&type=script&lang=js"
export * from "./GSTR.vue?vue&type=script&lang=js"
import style0 from "./GSTR.vue?vue&type=style&index=0&id=7057fa3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports